import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvisiaObjects} from '../../common/wrapper.models';
import {Additional, Category, FinderSearchItemData, FinderSearchItemList} from './finder.models';
import {map} from 'rxjs/operators';
import {EnvisiaLocation} from '../../common/location/envisia-location';
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class FinderSearchService {
  private url = environment.apiv4uri + 'finder/';

  constructor(private http: HttpClient) {
  }

  category(): Observable<Category[]> {
    return this.http.post<EnvisiaObjects<Category>>(
      this.url + 'category/',
      {}
      ).pipe(map(value => value.objects));
  }

  process(): Observable<Category[]> {
    return this.http.post<EnvisiaObjects<Category>>(
      this.url + 'process/',
      {}
    ).pipe(map(value => value.objects));
  }

  search(typ: string, id: string | number, params: any = {page: 0}): Observable<FinderSearchItemList> {
    return this.http.get<FinderSearchItemList>(
      this.url + 'search/' + typ + '/' + id + '/',
      {params: EnvisiaLocation.httpParams(params)}
    );
  }

  poll(uuid: string): Observable<{status: string, data: FinderSearchItemData[]}> {
    return this.http.get<{status: string, data: FinderSearchItemData[]}>(this.url + 'poll/' + uuid + '/');
  }

  additional(body: any): Observable<Additional[]> {
    return this.http.post<EnvisiaObjects<Additional>>(this.url + 'additional/', body).pipe(
      map(val => val.objects)
    );
  }

}
